import React from 'react';
import { Modal } from 'react-bootstrap';

export const LLEGADA_SIN_TURNO = 'SIN_TURNO';
export const LLEGADA_EXPRES = 'EXPRES';
export const LLEGADA_REATENCION = 'REATENCION';

const OPCIONES_LLEGADA = [
    {
        valor: LLEGADA_SIN_TURNO,
        icono: 'bi-person-walking',
        titulo: 'Llegó cliente sin turno',
        ayuda: 'Se registra como sobreturno y pasa a la cola de atención.',
    },
    {
        valor: LLEGADA_EXPRES,
        icono: 'bi-folder-symlink',
        titulo: 'Solo entrega / retira documentación',
        ayuda: 'Trámite exprés: queda finalizado en el acto. No cuenta en estadísticas.',
    },
    {
        valor: LLEGADA_REATENCION,
        icono: 'bi-person-lines-fill',
        titulo: 'Requiere ser atendido nuevamente',
        ayuda: 'Ya fue atendido hoy y vuelve a la cola. No cuenta en estadísticas.',
    },
];

/**
 * "Llegó cliente" del Panel Diario: elige a qué viene la persona que está en el mostrador. Solo
 * elige; el padre abre el flujo que corresponde (alta espontánea, trámite exprés o reingreso).
 */
function ModalLlegoCliente({ show, onCerrar, onElegir }) {
    return (
        <Modal className="rec-modal" show={show} onHide={onCerrar} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="bi bi-door-open-fill me-2"></i>
                    Llegó cliente
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="fw-semibold mb-2">¿A qué viene?</p>
                <div className="rec-llegada-opciones">
                    {OPCIONES_LLEGADA.map((opcion) => (
                        <button
                            key={opcion.valor}
                            type="button"
                            className="rec-reingreso-opcion rounded-4"
                            onClick={() => onElegir(opcion.valor)}
                        >
                            <i className={`bi ${opcion.icono} rec-reingreso-opcion-icono`}></i>
                            <span>
                                <span className="rec-reingreso-opcion-titulo d-block">{opcion.titulo}</span>
                                <span className="rec-reingreso-opcion-ayuda d-block">{opcion.ayuda}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ModalLlegoCliente;
